import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';

AgencyReconciliationCardView.propTypes = {
    name: PropTypes.string,
    value: PropTypes.number,
    unit: PropTypes.string,
    descriptionValue: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    nameColor: PropTypes.string,
    valueColor: PropTypes.string,
    unitColor: PropTypes.string,
    valueFontSize: PropTypes.number,
    showIcon: PropTypes.bool,
    showBorder: PropTypes.bool,
    additionalDes: PropTypes.element,
};

function AgencyReconciliationCardView(props) {
    // MARK: ---- PROPERTIES ----
    const {
        name,
        value,
        unit,
        descriptionValue,
        icon,
        color,
        backgroundColor = '#fff',
        nameColor = AppColors.gray[600],
        valueColor = AppColors.gray[800],
        unitColor = AppColors.gray[800],
        valueFontSize = 18,
        showIcon = true,
        showBorder = true,
        additionalDes = <></>,
    } = props;

    return (
        <div
            className="overflow-hidden position-relative"
            style={{
                border: showBorder ? `1px solid ${AppColors.gray[300]}` : '',
                borderBottom: showBorder ? `5px solid ${color}` : '',
                borderRadius: '10px',
            }}
        >
            <div
                style={{
                    backgroundColor: backgroundColor,
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px',
                }}
            >
                {/* header */}
                <div
                    className="d-flex gap-1 px-4 pt-4 align-items-center"
                >
                    <span style={UIHelper.buildFontStyle('600', `${valueFontSize}px`, valueColor)}>{Utils.formatNumber(value)}</span>
                    <span style={UIHelper.buildFontStyle('600', `${valueFontSize}px`, unitColor)}>{unit}</span>
                </div>
                {/* body */}
                <div className="d-flex gap-1 align-items-center px-4 pb-4">
                    <div>
                        <span style={UIHelper.buildFontStyle('500', '13px', nameColor)}>{name}</span>{' '}
                        {descriptionValue?.length && (
                            <span style={UIHelper.buildFontStyle('500', '13px', nameColor)}>({descriptionValue})</span>
                        )}
                    </div>
                    <div>{additionalDes}</div>
                </div>
            </div>

            {/* icon */}
            {icon && showIcon && (
                <div
                    className="position-absolute rounded-circle"
                    style={{
                        width: '110px',
                        height: '110px',
                        backgroundColor: color,
                        top: '-20px',
                        right: '-15px',
                        opacity: 0.15,
                    }}
                >
                    <i
                        className={`w-100 h-100 fa-fw ${icon}`}
                        style={{ fontSize: '50px', color: '#fff', paddingTop: '30px', paddingRight: '5px' }}
                    />
                </div>
            )}
        </div>
    );
}

export default AgencyReconciliationCardView;
